import React, { Component } from "react";
import { Button, Card, Container, Spinner } from "react-bootstrap";
import PixelfedLogoSvg from '../resources/images/pixelfed-logo.svg';
import { RiPixelfedFill } from 'react-icons/ri';
import RestServiceStatic from "../services/rest.service"

export default class FollowingList extends Component {

    constructor(props) {

        super(props);

        this.state = {
            isLoading: false,
            pixelfedUserId: "",
            followed: [],
            retry: false,
        }

        this.getLink = this.getLink.bind(this);
        this.follow = this.follow.bind(this);
    }

    getLink(username, instance, type) {

        let mastodonInstance = localStorage.getItem('MastodonInstance');
        let pixelfedInstance = localStorage.getItem('PixelfedInstance');

        if (type === "mastodon") {
            return "https://" + mastodonInstance + "/@" + username + (mastodonInstance === instance ? "" : "@" + instance);
        } else {
            return "https://" + pixelfedInstance + "/@" + username + (pixelfedInstance === instance ? "" : "@" + instance);
        }
    }

    follow(user, index) {

        this.setState({ isLoading: true, retry: false, pixelfedUserId: user.pixelfedUserId });

        let pixelfedToken = localStorage.getItem('pixelfedToken');
        let pixelfedInstance = localStorage.getItem('pixelfedInstance');

        RestServiceStatic.follow(pixelfedToken, pixelfedInstance, user).then(response => {

            if (response.data) {

                let followed = this.state.followed;
                followed.push(index);

                this.setState({
                    followed: followed,
                    isLoading: false,
                });

                return;
            } 

            this.setState({
                retry: true,
                isLoading: false,
            });

            

        }).catch(e => {

            console.log("CATCH:" + e);
            
            this.setState({
                retry: true,
                isLoading: false,
            });

        });
    }

    render() {
        return (
        <Container>
            <div className="row gy-4">
                {this.props.followings && this.props.followings.map((usr, index) => (
                    <div className="col-12" key={index}>
                        <Card className="followCard">
                            <Card.Body>
                                <div className="card-text">
                                    <div className="row">
                                        <div className="col-sm-4 text-truncate">
                                            <div className="d-flex">
                                                <div className="p-2">
                                                    <div className="p-relative">
                                                        <img src={usr.mastodonAvatar} className="rounded-circle border align-items-center avatar text-start" alt="User Avatar" />
                                                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill icon-badge mastodon-color">
                                                            <i className="bi bi-mastodon"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="p-2 text-truncate">
                                                    <h6 className="name text-truncate" title={usr.mastodonName}> 
                                                    <a href={this.getLink(usr.mastodonUsername, usr.mastodonInstance, 'mastodon')} target='_blank' rel="noreferrer">{usr.mastodonName}</a></h6>
                                                    <p className="username text-muted text-truncate"  title={"@" + usr.mastodonUsername + "@" + usr.mastodonInstance}> 
                                                        @{usr.mastodonUsername}@{usr.mastodonInstance}
                                                    </p>
                                                    <p className="text-truncate note text-muted" title={usr.mastodonNote}>{usr.mastodonNote}</p>                                                            
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-2 d-flex justify-content-center">
                                            <div className="d-flex justify-content-center">
                                                <div className="p-2 align-self-center text-center">
                                                    <i className="fs-4 bi iconArrow bi-arrow-down-circle text-primary"></i><br/>
                                                    {this.props.verified ?
                                                    <span className="confident-text text-success"><i className="bi bi-patch-check-fill"></i> Verified </span> :
                                                    <span className="confident-text text-warning"><i className="bi bi-patch-exclamation-fill"></i> 
                                                        {usr.accuracy === 0 ? " Not verified" : " " + usr.accuracy + (usr.accuracy === 1 ?  " user thinks " : " users think ") + "it's correct"} 
                                                    </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-4 text-truncate">
                                            <div className="d-flex">
                                                <div className="p-2">
                                                    <div className="p-relative">
                                                        <img src={usr.pixelfedAvatar} className="rounded-circle border align-items-center avatar text-start" alt="User Avatar" />
                                                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill icon-badge pixelfed-color">
                                                            <img src={PixelfedLogoSvg} style={{ height: 18, width: 18 }} alt="Pixelfed icon" />
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="p-2">
                                                    <h6 className="name text-truncate" title={usr.pixelfedName}> 
                                                    <a href={this.getLink(usr.pixelfedUsername, usr.pixelfedInstance, 'pixelfed')} target='_blank' rel="noreferrer">{usr.pixelfedName}</a></h6>
                                                    <p className="username text-muted text-truncate" title={"@" + usr.pixelfedUsername + "@" + usr.pixelfedInstance}>@{usr.pixelfedUsername}@{usr.pixelfedInstance}</p>
                                                    <p className="pixelfedStats text-muted text-truncate">
                                                        {usr.pixelfedFollowersCount} <i className="bi bi-arrow-left-circle" title="Followers"></i>&nbsp;&nbsp;&nbsp;
                                                        {usr.pixelfedFollowingCount} <i className="bi bi-arrow-right-circle" title="Followings"></i>&nbsp;&nbsp;&nbsp;
                                                        {usr.pixelfedStatusesCount} <i className="bi bi-images" title="Posts"></i>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className="d-flex justify-content-center">
                                                <div className="p-2 align-self-center mt-4">
                                                    {this.state.followed.includes(index)
                                                        ? <Button variant="success" disabled><i className="bi bi-check-circle" /> Followed</Button>
                                                        : <Button variant="primary" onClick={() => this.follow(usr, index)}>
                                                            {this.state.isLoading && this.state.pixelfedUserId === usr.pixelfedUserId
                                                                ? <Spinner as="span" animation="grow" role="status" aria-hidden="true" size="sm" />
                                                                : <RiPixelfedFill size={18} className="react-icon-fix"/>} 
                                                                {this.state.retry && this.state.pixelfedUserId === usr.pixelfedUserId ? " Retry" : " Follow"}
                                                          </Button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Card.Body>
                        </Card>
                    </div>
                ))}
            </div>
        </Container>
        );
    }
}
